var _polygon, _polygon2, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNounInbox146533(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100px",
    width: "100px",
    fill: "#000000",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "82.5641098,42.6239014 17.874155,42.6239014 28.4445076,26.225935 74.0025024,26.225935 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "20.0710106,46.6539116 17.0403595,52.3515091 82.9576569,52.3515091 80.5029373,46.6539116 "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M88.181076,46.6539116h-4.0875397l4.7766724,9.8665733H67.4216995c0,8.2888412-6.7191963,15.0083084-15.0077553,15.0083084  c-8.2890892,0-15.0083084-6.7194672-15.0083084-15.0083084H11.06672l4.7772274-9.8665733h-4.0875406L5,56.5204849v26.1255722  h89.9374847V56.5204849L88.181076,46.6539116z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNounInbox146533);
export default __webpack_public_path__ + "static/media/noun_inbox_146533.b6aeb7de.svg";
export { ForwardRef as ReactComponent };